import { Routes } from '@angular/router'
import { PUBLIC_ROUTES } from './public/public.routes'
import { SECURE_ROUTES } from './secure/secure-routing-module'
import { PublicComponent } from './layouts/public.component'
import { SecureComponent } from './layouts/secure.component'
import { trialGuardFn } from './core/guards/trial.guard'
import { authGuardFn } from '@auth0/auth0-angular'
import { ForbiddenComponent } from './secure/modules/forbidden/forbidden.component'

export const ROUTES: Routes = [
    { path: '', redirectTo: '/customers', pathMatch: 'full' },
    {
        path: '',
        component: PublicComponent,
        data: { title: 'Public Views' },
        children: PUBLIC_ROUTES,
    },
    {
        path: '',
        component: SecureComponent,
        canActivate: [authGuardFn],
        canActivateChild: [authGuardFn, trialGuardFn],
        data: { title: 'Secure Views' },
        children: SECURE_ROUTES,
    },
    {
        path: 'forbidden',
        component: ForbiddenComponent,
        title: 'Forbidden',
    },
    { path: '**', redirectTo: '/forbidden' },
]

// @NgModule({
//     imports: [
//         RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled', paramsInheritanceStrategy: 'always' }),
//     ],
//     exports: [RouterModule],
// })
// export class AppRoutingModule {}
